module.exports = "<span class=\"badge badge-primary link-text\" (click)=\"show()\">&nbsp;?&nbsp;</span>\n\n<div class=\"modal\" *ngIf=\"visible\">\n    <div class=\"modal-box\">\n        <div class=\"modal-box-content\">\n            <div class=\"title\">{{title}} <a class=\"modal-box-close\" (click)=\"hide()\">&times;</a></div>\n            <div class=\"text\">\n                <ng-content></ng-content>\n            </div>\n        </div>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/mjahoo/workspace/rento/git/saunasampo-monitor/src/app/dialog/dialog.component.html
// module id = ../../../../../src/app/dialog/dialog.component.html
// module chunks = main